import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { changePassword, setProfileComplete, PROFILE_FLAG } from "../../actions/auth/auth";
import { getLocalStorage } from "../../helpers/localStorage";
import { AlertMessage } from "../customComponent/AlertMessage";
import { ButtonSpinner } from "../customComponent/buttonSpiner/ButtonSpinner";

export const CompleteProfileModal = () => {
  const dispatch = useDispatch();
  const { uid, isProfileComplete } = useSelector((state) => state.auth);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const localFlag = getLocalStorage(PROFILE_FLAG);
  if (Number(localFlag) === 1 && Number(isProfileComplete) === 1) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6)
      return AlertMessage("Ups.!", "La contraseña debe tener al menos 6 caracteres", "error");
    if (password !== confirmPassword)
      return AlertMessage("Ups.!", "Las contraseñas deben coincidir", "error");
    try {
      setIsLoading(true);
      const rpta = await changePassword({ id: uid, password });
      if (rpta.ok) {
        dispatch(setProfileComplete());
        AlertMessage("Ok.!", "Contraseña actualizada", "success");
      } else AlertMessage("Ups.!", rpta.data?.message, "error");
    } catch (error) {
      AlertMessage("Ups.!", "Ocurrió un error", "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="modal fade show"
      style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
      tabIndex="-1"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5">Crea tu nueva contraseña</h1>
          </div>
          <div className="modal-body background_color">
            <p>Por seguridad debes establecer una nueva contraseña para continuar.</p>
            <form onSubmit={handleSubmit}>
              <div className="d-flex gap-2 flex-column">
                <input
                  className="form-control"
                  type="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <input
                  className="form-control"
                  type="password"
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
                <div className="text-end my-2">
                  {isLoading ? (
                    <ButtonSpinner />
                  ) : (
                    <button type="submit" className="btn btn-outline-success">
                      <i className="fa-solid fa-circle-check"></i> Guardar
                    </button>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
